// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ZIP_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const Rules = {
  required: (value?: string | null): boolean | string => !!value || "Required",
  requiredAtLeastOne: (value?: any[] | null): boolean | string => {
    if (value && value.length > 0) {
      return true;
    }
    return "Required";
  },
  requiredPositiveInteger: (value?: string | null): boolean | string => {
    if (!value) return "Invalid";
    const valueIsInteger = parseInt(value).toString() === value.toString();
    if (value && valueIsInteger && parseInt(value) > 0) {
      return true;
    }
    return "Invalid";
  },
  requiredIfInUnitedStates: (country?: string) => (value?: string | null): boolean | string => {
    if (country === "United States of America (the)") {
      return !!value || "Required";
    } else {
      return true;
    }
  },
  matches: (matched: string, name: string) => (value?: string | null): boolean | string =>
    matched === value || `Must match ${name}`,
  email: (value?: string | null): boolean | string => !!value?.match(EMAIL_REGEX) || "Invalid Email",
};
